import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { PlacementType, Tooltip } from 'embed/components/Tooltip'
import AdvertiserDisclosureContent from './AdvertiserDisclosureContent'

const styles = require('./styles')

const contentOverlay = <AdvertiserDisclosureContent />

interface Props {
  className?: string
  tooltipPlacement?: PlacementType
}

const AdvertiserDisclosure = ({ className, tooltipPlacement }: Props) => (
  <ThemeConsumer>
    {({ colorPrimary }) => (
      <Tooltip overlay={contentOverlay} placement={tooltipPlacement}>
        <a
          data-test-id="adDisclosure"
          className={classnames(
            styles.adDisclosure,
            className,
            css`
              color: ${colorPrimary};
            `,
          )}
        >
          Advertiser&nbsp;Disclosure
        </a>
      </Tooltip>
    )}
  </ThemeConsumer>
)

export { AdvertiserDisclosureContent }
export default AdvertiserDisclosure
